module.exports = __webpack_public_path__ + "static/media/flower11.edba1822.png";